import { render, staticRenderFns } from "./ConsumivelModal.vue?vue&type=template&id=862a2f0c&scoped=true"
import script from "./ConsumivelModal.vue?vue&type=script&lang=js"
export * from "./ConsumivelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862a2f0c",
  null
  
)

export default component.exports